<h2 mat-dialog-title>Repas payé par l'entreprise</h2>

<mat-dialog-content>
	<p class="intro">
		Les jours saisis ici <b>n'ouvrent pas droit au titre-restaurant</b> : le repas est déjà pris
		en charge, le titre ferait double emploi.
	</p>

	<div class="flexrow gap">
		<mat-form-field class="narrow">
			<mat-label>Du</mat-label>
			<input matInput [matDatepicker]="pickStart" [min]="minDate" [max]="maxDate"
				[value]="dateOf(datestart)" (dateChange)="onDate('start', $event.value)">
			<mat-datepicker-toggle matIconSuffix [for]="pickStart"></mat-datepicker-toggle>
			<mat-datepicker #pickStart></mat-datepicker>
		</mat-form-field>
		<mat-form-field class="narrow">
			<mat-label>Au</mat-label>
			<input matInput [matDatepicker]="pickEnd" [min]="minDate" [max]="maxDate"
				[value]="dateOf(dateend)" (dateChange)="onDate('end', $event.value)">
			<mat-datepicker-toggle matIconSuffix [for]="pickEnd"></mat-datepicker-toggle>
			<mat-datepicker #pickEnd></mat-datepicker>
		</mat-form-field>
		<mat-form-field class="kind-select">
			<mat-label>Nature</mat-label>
			<mat-select [(ngModel)]="kind">
				@for (k of kinds; track k.id) {
					<mat-option [value]="k.id" [matTooltip]="k.hint">{{ k.label }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>

	<mat-form-field class="full">
		<mat-label>Précision (facultatif)</mat-label>
		<input matInput [(ngModel)]="comment" maxlength="120" placeholder="Formation SAV, déjeuner compris">
		<mat-hint>Ce qui justifiera la retenue si quelqu'un demande pourquoi</mat-hint>
	</mat-form-field>

	<div class="people-head">
		<span class="people-title">Qui a mangé aux frais de l'entreprise&nbsp;?</span>
		<button mat-stroked-button class="mini" (click)="selectWorking()">Tous ceux qui travaillent</button>
		<button mat-stroked-button class="mini" (click)="clearSelection()" [disabled]="!selected.size">Aucun</button>
	</div>

	<ul class="people">
		@for (e of data.employees; track e.id) {
			<li [class.off]="!e.working">
				<mat-checkbox [checked]="selected.has(e.id)" (change)="toggle(e.id)">
					{{ e.name }}
				</mat-checkbox>
				@if (!e.working) {
					<span class="tag" matTooltip="Aucun créneau sur la période choisie">ne travaille pas</span>
				}
				@if (e.already) {
					<span class="tag warn" matTooltip="Un repas est déjà saisi : il sera remplacé">déjà saisi</span>
				}
			</li>
		}
	</ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<span class="recap">
		@if (valid) {
			{{ selected.size }} personne{{ selected.size > 1 ? 's' : '' }} ×
			{{ days.length }} jour{{ days.length > 1 ? 's' : '' }} =
			<b>{{ count }} repas</b>
			<span class="days">({{ days[0] ? dayLabel(days[0]) : '' }}@if (days.length > 1) { → {{ dayLabel(days[days.length - 1]) }} })</span>
		} @else {
			Choisissez au moins une personne et une date.
		}
	</span>
	<button mat-button (click)="onCancel()">Annuler</button>
	<button mat-flat-button color="primary" [disabled]="!valid" (click)="onValidate()">Enregistrer</button>
</mat-dialog-actions>
